const rainSystem = {
  emitters: [
    {
      id: 1,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.75, 0],
          [1.1, 0],
        ],
      },
      speed: {
        type: 'range',
        value: [4.5, 5.5],
      },
      angle: {
        type: 'float',
        value: 0.4,
      },
      rate: {
        type: 'float',
        value: 5,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'line',
        },
        gravity: {
          type: 'float',
          value: 0.01,
        },
        color: {
          type: 'color',
          value: [12, 82, 173, 1],
        },
      },
    },

    {
      id: 2,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.75, 0],
          [1.1, 0],
        ],
      },
      speed: {
        type: 'range',
        value: [4.5, 5.5],
      },
      angle: {
        type: 'float',
        value: 0.4,
      },
      rate: {
        type: 'float',
        value: 5,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'line',
        },
        gravity: {
          type: 'float',
          value: 0.01,
        },
        color: {
          type: 'color',
          value: [12, 82, 173, 0.3],
        },
      },
    },
    {
      id: 3,
      name: '',
      position: {
        type: 'vectorRange',
        value: [
          [-0.75, 0],
          [1.1, 0],
        ],
      },
      speed: {
        type: 'range',
        value: [4.5, 5.5],
      },
      angle: {
        type: 'float',
        value: 0.4,
      },
      rate: {
        type: 'float',
        value: 5,
      },
      particle: {
        shape: {
          type: 'string',
          value: 'line',
        },
        gravity: {
          type: 'float',
          value: 0.01,
        },
        color: {
          type: 'color',
          value: [23, 48, 82, 0.3],
        },
      },
    },
  ],
  effects: [],
}

export default rainSystem
